import { StyledIconLamp } from './IconLamp.styled';

const IconLamp = () => {
  return <StyledIconLamp />;
};

export default IconLamp;
